// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3-Da5","head":"ProcedureTableInfo_head__36WVQ"};